export { default } from './FocalPointImage';

export * from './FocalPointImage';
